import { CardSkeleton } from './card-skeleton';
import { SectionHeaderSkeleton } from './section-header-skeleton';

export const SectionSkeleton = ({ cardCount = 3 }: { cardCount?: number }) => (
  <div className='space-y-4'>
    <SectionHeaderSkeleton />
    <div className='space-y-4'>
      {Array.from({ length: cardCount }, (_, i) => (
        <CardSkeleton key={`preset-card-${i}`} />
      ))}
    </div>
  </div>
);
